import React, {createContext, useContext, useEffect, useState} from 'react';
import instance from '../instance';

interface IOFDData {
    [id: number]: any;
}

interface IKKMTypeData {
    [id: number]: any;
}

interface IConstantsContext {
    OFD: IOFDData | null;
    KKMType: IKKMTypeData | null;
}

interface IProps {
    children: React.ReactNode;
    isAuth: boolean;
    userId: number | null;
}

const ConstantsContext = createContext<IConstantsContext>({
    OFD: null,
    KKMType: null,
});

export const ConstantsContextProvider = ({children, isAuth, userId}: IProps) => {
    const [OFD, setOFD] = useState<IOFDData | null>(null);
    const [KKMType, setKKMType] = useState<IKKMTypeData | null>(null);

    const fetchGetOFD = async () => {
        try {
            const response = await instance.post('/LK', {method: 'GetOFD', params: {}});
            setOFD(response.data?.ofd ?? null);
        } catch (error) {
            console.error('GetOFD error:', error);
        }
    };

    const fetchGetKKMType = async () => {
        try {
            const response = await instance.post('/LK', {method: 'GetKKMType', params: {}});
            setKKMType(response.data?.kkm_type ?? null);
        } catch (error) {
            console.error('GetKKMType error:', error);
        }
    };

    useEffect(() => {
        if (!isAuth || !userId) return;
        void fetchGetOFD();
        void fetchGetKKMType();
    }, [isAuth, userId]);

    return <ConstantsContext.Provider value={{OFD, KKMType}}>{children}</ConstantsContext.Provider>;
};

export function GetConstants(): IConstantsContext {
    return useContext(ConstantsContext);
}

export default GetConstants;
